import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { FormFieldStyle } from "@insite/mobius/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
    pagination: getProductListDataViewProperty(state, "pagination")?.totalItemCount,
});

type Props = ReturnType<typeof mapStateToProps> & WidgetProps;
let cartCount: number | undefined;

export interface ProductListControlsContainerStyles {
    container?: GridContainerProps;
    noProductContainer?: GridContainerProps;
    sortGridItem?: GridItemProps;
    sortTableViewGridItem?: GridItemProps;
    filterGridItem?: GridItemProps;
    filterTableViewGridItem?: GridItemProps;
    viewPaginationGridItem?: GridItemProps;
    viewPaginationTableViewGridItem?: GridItemProps;
}

export const controlsContainerStyles: ProductListControlsContainerStyles = {
    container: {
        gap: 0,
        css: css`
            > ${GridOffset} {
                border: 1px solid ${getColor("common.border")};
                padding: 0px 10px;
                > ${GridItemStyle}:first-child {
                    > div[class^="Wrapper"] {
                        margin: 10px 0px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    display: flex;
                                    justify-content: center;
                                    margin: 1rem 0rem 0rem;
                                `,
                                css`
                                    display: flex;
                                    justify-content: center;
                                    margin: 1rem 0rem 0rem;
                                `,
                                css`
                                    display: flex;
                                    justify-content: center;
                                    margin: 1rem 0rem 0rem;
                                `,
                                null,
                                null,
                            ])}
                        >${FormFieldStyle} {
                            label {
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(theme, [
                                        null,
                                        null,
                                        null,
                                        css`
                                            padding: 9px 4px 0 0;
                                        `,
                                        null,
                                    ])}
                            }
                        }
                    }
                }
                > ${GridItemStyle}:last-child {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                margin-top: -4px;
                            `,
                            css`
                                margin-top: -4px;
                            `,
                            css`
                                margin-top: -4px;
                            `,
                            null,
                            null,
                        ])}
                }
                /* background-color: ${getColor("secondary")}; */
                /* margin-top: 10px; */
                /* padding: 0px 10px 0px 20px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        css`
                            padding: 0px 10px 0px 12px;
                        `,
                        null,
                    ])} */
            }
        `,
    },
    noProductContainer: {
        gap: 0,
        css: css`
            > ${GridOffset} {
                background-color: none;
                margin-top: 10px;
                padding: 0px 10px 0px 20px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        css`
                            padding: 0px 10px 0px 12px;
                        `,
                        null,
                    ])}
            }
        `,
    },
    sortGridItem: {
        width: [12, 12, 12, 6, 3],
    },
    sortTableViewGridItem: {
        width: [12, 12, 12, 6, 3],
    },
    filterGridItem: {
        width: 0,
    },
    filterTableViewGridItem: {
        width: 0,
    },
    viewPaginationGridItem: {
        width: [12, 12, 12, 6, 9],
        css: css`
            ${({ theme }: { theme: BaseTheme }) => breakpointMediaQueries(theme, [null, null, null, null, null])}
        `,
    },
    viewPaginationTableViewGridItem: {
        width: [12, 12, 12, 6, 9],
        css: css`
            ${({ theme }: { theme: BaseTheme }) => breakpointMediaQueries(theme, [null, null, null, null, null])}
        `,
    },
};

const styles = controlsContainerStyles;

const SunSourceProductListHeaderControlsContainer: React.FC<Props> = ({ id, view, pagination }) => {
    if (typeof pagination !== "undefined") {
        cartCount = pagination;
    }
    return (
        <GridContainer {...(cartCount !== 0 ? styles.container : styles.noProductContainer)}>
            <GridItem {...(view === "Table" ? styles.sortTableViewGridItem : styles.sortGridItem)}>
                {cartCount !== 0 && <Zone contentId={id} zoneName="SortDiv" />}
            </GridItem>
            {/* <GridItem {...(view === "Table" ? styles.filterTableViewGridItem : styles.filterGridItem)}>
                <Zone contentId={id} zoneName="FilterDiv" />
            </GridItem> */}
            <GridItem {...(view === "Table" ? styles.viewPaginationTableViewGridItem : styles.viewPaginationGridItem)}>
                <Zone contentId={id} zoneName="PaginationDiv" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(SunSourceProductListHeaderControlsContainer),
    definition: {
        group: "Product List",
        displayName: "Header List Controls Container",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
